/*
  Miracle Glow — interactions de la landing produit.
  - apparition douce des éléments au scroll (uniquement ceux hors écran au chargement)
  - parallax très léger sur l'image de campagne
  - interrupteur « Glow mode: on »
  - barre d'achat collante + bouton du CTA final branchés sur le vrai bouton
    « Ajouter au panier » de la section produit (panier, abonnement, suivi inchangés)
*/
(function () {
  if (window.mcGlow) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Bouton d'ajout au panier de la section produit (Dawn)
  function mainAddButton() {
    return document.querySelector('.mc-glow-main button[name="add"]') ||
      document.querySelector('product-info button[name="add"]');
  }

  function initReveal(root) {
    const items = root.querySelectorAll('[data-mcg-reveal]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mcg-in');
        entry.target.classList.remove('mcg-pending');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    items.forEach((el) => {
      // Ce qui est déjà visible reste visible : pas de clignotement
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('mcg-pending');
      io.observe(el);
    });
  }

  function initParallax(root) {
    if (reduceMotion) return;
    root.querySelectorAll('[data-mcg-parallax]').forEach((wrap) => {
      const img = wrap.querySelector('img');
      if (!img || wrap.dataset.mcgBound) return;
      wrap.dataset.mcgBound = '1';
      let ticking = false;
      const update = () => {
        const r = wrap.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          img.style.transform = `translate3d(0, ${(p * -18).toFixed(1)}px, 0) scale(1.05)`;
        }
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  }

  function initSwitch(root) {
    root.querySelectorAll('[data-mcg-switch]').forEach((sw) => {
      if (reduceMotion || !('IntersectionObserver' in window)) {
        sw.classList.remove('is-off');
        return;
      }
      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        setTimeout(() => sw.classList.remove('is-off'), 250);
        io.disconnect();
      }, { threshold: 1 });
      io.observe(sw);
    });
  }

  // Le bouton du CTA final et celui de la barre collante déclenchent le vrai
  // bouton de la section produit. Sans lui, le formulaire classique prend le relais.
  function initBuy(root) {
    root.querySelectorAll('form[data-mcg-buy]').forEach((form) => {
      if (form.dataset.mcgBound) return;
      form.dataset.mcgBound = '1';
      form.addEventListener('submit', (event) => {
        const main = mainAddButton();
        if (!main || main.disabled) return;
        event.preventDefault();
        main.click();
      });
    });
  }

  function initSticky(root) {
    const bar = root.querySelector('[data-mcg-sticky]');
    if (!bar || bar.dataset.mcgBound) return;
    bar.dataset.mcgBound = '1';

    const anchor = document.querySelector('.mc-glow-main .product-form__buttons') ||
      document.querySelector('.mc-glow-main');
    const final = document.querySelector('[data-mcg-final]');

    // Calcul à chaque défilement (et non par IntersectionObserver) : un saut
    // direct par ancre ou un défilement très rapide ne doit pas être manqué.
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      const pastHero = !anchor || anchor.getBoundingClientRect().bottom < 0;
      let onFinal = false;
      if (final) {
        const r = final.getBoundingClientRect();
        onFinal = r.top < vh * 0.75 && r.bottom > 0;
      }
      const on = pastHero && !onFinal;
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init(root) {
    initReveal(root);
    initParallax(root);
    initSwitch(root);
    initBuy(root);
    initSticky(root);
  }

  window.mcGlow = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Éditeur de thème : réinitialiser une section rechargée
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
